export const GOOGLE_FONTS: string[] = [
  'ABeeZee',
  'Abel',
  'Abril Fatface',
  'Acme',
  'Alata',
  'Alegreya',
  'Alegreya Sans',
  'Alfa Slab One',
  'Alice',
  'Alike',
  'Allan',
  'Amiri',
  'Anek Latin',
  'Anton',
  'Architects Daughter',
  'Archivo',
  'Archivo Black',
  'Archivo Narrow',
  'Arimo',
  'Arsenal',
  'Arvo',
  'Asap',
  'Asap Condensed',
  'Assistant',
  'Babylonica',
  'Balsamiq Sans',
  'Bangers',
  'Barlow',
  'Barlow Condensed',
  'Barlow Semi Condensed',
  'Be Vietnam Pro',
  'Bebas Neue',
  'Bitter',
  'Black Ops One',
  'Bodoni Moda',
  'Bree Serif',
  'Cabin',
  'Cairo',
  'Cantarell',
  'Cardo',
  'Catamaran',
  'Caveat',
  'Chakra Petch',
  'Chivo',
  'Cinzel',
  'Comfortaa',
  'Commissioner',
  'Concert One',
  'Cormorant',
  'Cormorant Garamond',
  'Courgette',
  'Crete Round',
  'Crimson Pro',
  'Crimson Text',
  'Cuprum',
  'DM Mono',
  'DM Sans',
  'DM Serif Display',
  'DM Serif Text',
  'Dancing Script',
  'Darker Grotesque',
  'Didact Gothic',
  'Domine',
  'Dosis',
  'EB Garamond',
  'Eczar',
  'El Messiri',
  'Encode Sans',
  'Encode Sans Condensed',
  'Exo',
  'Exo 2',
  'Fira Code',
  'Fira Sans',
  'Fira Sans Condensed',
  'Fjalla One',
  'Francois One',
  'Frank Ruhl Libre',
  'Fraunces',
  'Fredoka',
  'Gelasio',
  'Gloria Hallelujah',
  'Gothic A1',
  'Great Vibes',
  'Gruppo',
  'Heebo',
  'Hind',
  'Hind Madurai',
  'Hind Siliguri',
  'IBM Plex Mono',
  'IBM Plex Sans',
  'IBM Plex Sans Arabic',
  'IBM Plex Sans Condensed',
  'IBM Plex Serif',
  'Inconsolata',
  'Indie Flower',
  'Inter',
  'Inter Tight',
  'Italiana',
  'Jost',
  'Josefin Sans',
  'Josefin Slab',
  'Kalam',
  'Kanit',
  'Karla',
  'Kaushan Script',
  'Khand',
  'Lato',
  'League Spartan',
  'Lexend',
  'Lexend Deca',
  'Libre Baskerville',
  'Libre Caslon Text',
  'Libre Franklin',
  'Lilita One',
  'Lobster',
  'Lobster Two',
  'Lora',
  'Lusitana',
  'Macondo',
  'Manrope',
  'Marcellus',
  'Martel',
  'Maven Pro',
  'Merienda',
  'Merriweather',
  'Merriweather Sans',
  'Mitr',
  'Montserrat',
  'Montserrat Alternates',
  'Mukta',
  'Mulish',
  'Nanum Gothic',
  'Nanum Myeongjo',
  'Neuton',
  'Noto Sans',
  'Noto Sans Arabic',
  'Noto Sans Display',
  'Noto Sans HK',
  'Noto Sans JP',
  'Noto Sans KR',
  'Noto Sans SC',
  'Noto Sans TC',
  'Noto Serif',
  'Noto Serif JP',
  'Nunito',
  'Nunito Sans',
  'Old Standard TT',
  'Oleo Script',
  'Open Sans',
  'Orbitron',
  'Oswald',
  'Outfit',
  'Overpass',
  'Oxygen',
  'PT Mono',
  'PT Sans',
  'PT Sans Caption',
  'PT Sans Narrow',
  'PT Serif',
  'Pacifico',
  'Passion One',
  'Pathway Gothic One',
  'Patrick Hand',
  'Patua One',
  'Permanent Marker',
  'Philosopher',
  'Play',
  'Playfair Display',
  'Plus Jakarta Sans',
  'Poppins',
  'Prata',
  'Prompt',
  'Public Sans',
  'Quattrocento',
  'Quattrocento Sans',
  'Questrial',
  'Quicksand',
  'Rajdhani',
  'Raleway',
  'Readex Pro',
  'Red Hat Display',
  'Righteous',
  'Roboto',
  'Roboto Condensed',
  'Roboto Flex',
  'Roboto Mono',
  'Roboto Serif',
  'Roboto Slab',
  'Rokkitt',
  'Rowdies',
  'Rubik',
  'Rufina',
  'Russo One',
  'Sacramento',
  'Saira',
  'Saira Condensed',
  'Sarabun',
  'Satisfy',
  'Sawarabi Gothic',
  'Secular One',
  'Sen',
  'Shadows Into Light',
  'Signika',
  'Signika Negative',
  'Silkscreen',
  'Slabo 27px',
  'Sora',
  'Source Code Pro',
  'Source Sans 3',
  'Source Serif 4',
  'Space Grotesk',
  'Space Mono',
  'Spectral',
  'Tajawal',
  'Tangerine',
  'Teko',
  'Tinos',
  'Titillium Web',
  'Ubuntu',
  'Ubuntu Condensed',
  'Ubuntu Mono',
  'Unbounded',
  'Urbanist',
  'Varela Round',
  'Vollkorn',
  'Work Sans',
  'Yanone Kaffeesatz',
  'Yellowtail',
  'Zen Kaku Gothic New',
  'Zilla Slab',
];

const loadedFonts = new Set<string>();

export function loadGoogleFont(fontFamily: string): void {
  if (loadedFonts.has(fontFamily)) return;
  loadedFonts.add(fontFamily);

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}:wght@400;700&display=swap`;
  document.head.appendChild(link);
}

export function loadGoogleFontsPreview(fontFamilies: string[]): void {
  const unloaded = fontFamilies.filter(f => !loadedFonts.has(f));
  if (unloaded.length === 0) return;

  for (const font of unloaded) {
    loadedFonts.add(font);
  }

  const families = unloaded.map(f => `family=${encodeURIComponent(f)}`).join('&');
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?${families}&display=swap`;
  document.head.appendChild(link);
}
